import React, { useCallback, useEffect, useState } from "react";
import TransactionTable from "../components/TransactionTable";
import LoadingIcon from "../components/LoadingIcon";
import { Link } from "react-router-dom";
import TradingViewWidget from "../components/TradingViewWidget";
import TapeWidget from "../components/TapeWidget";
import { FaBullhorn } from "react-icons/fa";
import LiveTradingForm from "../components/LiveTrade";

const columns = [
  {
    name: "Amount",
    selector: (row) => (
      <div
        className={`
          ${row.transactionType === "Deposit" ||
            row.transactionType === "Earning"
            ? "text-green-600"
            : ""
          } 
           ${row.transactionType === "withdrawal" ? "text-red-600" : ""} ${row.transactionType === "Subscription" ? "text-blue-600" : ""
          } 
        `}
      >
        $ {parseInt(row.amount).toFixed(2)}
      </div>
    ),
    sortable: true,
  },
  {
    name: "Transaction Type",
    selector: (row) => <div className="capitalize"> {row.transactionType}</div>,
  },
  {
    name: "Date",
    selector: (row) => new Date(row.createdAt).toDateString(),
    sortable: true,
  },
];

const Dashboard = () => {
  const [user, setUser] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState();
  const [btcExchange, setBtcExchange] = useState(1);
  const [transactions, setTransactions] = useState([]);
  const token = localStorage.getItem("token");

  const getDetails = useCallback(async () => {
    setLoading(true);
    const response = await fetch(`${process.env.REACT_APP_API_URL}dashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    const response1 = await fetch(
      `${process.env.REACT_APP_API_URL}activity/all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    // const btcResponse = await fetch(
    //   "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd"
    // );

    // console.log(btcResponse);


    // const btcData = await btcResponse.json();

    setBtcExchange(98312);

    const data1 = await response1.json();

    const data = await response.json();

    setUser(data.user);
    setUserInfo(data);

    if (data1.status) {
      setTransactions(data1.userTransactions.splice(0, 5));
    }
    setLoading(false);
  }, [token]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  return (
    <div>
      <div className="mb-9">
        <h3 className="font-bold text-2xl text-white">Dashboard</h3>
      </div>
      {loading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <>
          {user.verified ? (
            ""
          ) : (
            <div className="bg-red-600 p-3 text-white rounded-md">
              <div>
                <h6 className="text-lg font-semibold">
                  Account not yet verified!
                </h6>
              </div>
              <p>
                Document verification is required to complete registration click{" "}
                <Link to={"/verify account"}>here</Link> to upload document
              </p>
            </div>
          )}
          {user.tradingStatus?.length > 0 && (
            <div className="flex w-full bg-slate-600 text-white rounded-md mt-7 p-3 items-center">
              <div className="mr-4">
                <FaBullhorn size={30} />
              </div>
              <div className="text-lg font-bold">{user.tradingStatus}</div>
            </div>
          )}

          <div className="md:flex block mt-6 text-sm font-bold">
            <div className="bg-[#1B4242] p-3 text-white w-full rounded-md">
              <h6>Balance</h6>
              <p className="m-0">${userInfo.acctBalance}</p>
              <p className="m-0">
                Bitcoin:{" "}
                {parseInt(userInfo.acctBalance).toFixed(4) /
                  parseInt(btcExchange).toFixed(4)}
              </p>
              {/* <p className="m-0">Ethereum: 0.00000000</p> */}
            </div>
          </div>
          <div className="md:flex block mt-6 text-sm font-bold">
            <div className="bg-[#1B4242] p-3 text-white w-full rounded-md mb-6">
              <h6>Bonus</h6>
              <p className="m-0">${parseInt(user.welcomeBonus).toFixed(2)}</p>
              <p className="m-0">
                Bitcoin:{" "}
                {parseInt(user.welcomeBonus).toFixed(4) /
                  parseInt(btcExchange).toFixed(4)}
              </p>
              {/* <p className="m-0">Ethereum: 0.00000000</p> */}
            </div>
            <div className="mx-2"></div>
            <div className="bg-[#1B4242] p-3 text-white w-full rounded-md mb-6">
              <h6>Total Deposit</h6>
              <p className="m-0">${userInfo.totalDeposit}</p>
              <p className="m-0">
                Bitcoin:{" "}
                {parseInt(userInfo.totalDeposit).toFixed(4) /
                  parseInt(btcExchange).toFixed(4)}
              </p>
              {/* <p className="m-0">Ethereum: 0.00000000</p> */}
            </div>
          </div>
          <div className="md:flex block text-sm font-bold">
            <div className="bg-[#1B4242] p-3 text-white w-full rounded-md mb-6">
              <h6>Total Withdraw</h6>
              <p className="m-0">${userInfo.totalWithdrawal}</p>
              <p className="m-0">
                Bitcoin:{" "}
                {parseInt(userInfo.totalWithdrawal).toFixed(4) /
                  parseInt(btcExchange).toFixed(4)}
              </p>
              {/* <p className="m-0">Ethereum: 0.00000000</p> */}
            </div>
            <div className="mx-2"></div>
            <div className="bg-[#1B4242] p-3 text-white w-full rounded-md mb-6">
              <h6>Profit return</h6>
              <p className="m-0">${userInfo.totalEarnings}</p>
              <p className="m-0">
                Bitcoin:{" "}
                {parseInt(userInfo.totalEarnings).toFixed(4) /
                  parseInt(btcExchange).toFixed(4)}{" "}
              </p>
              {/* <p className="m-0">Ethereum: 0.00000000</p> */}
            </div>
          </div>
          <div className="mt-10">
            <div className="mb-8">
              <TapeWidget />
            </div>
            <TradingViewWidget />
          </div>
          <div className="mt-10">
            <div className="mb-9">
              <h6 className="font-bold text-lg text-white">
                Recent Transactions
              </h6>
            </div>
            <TransactionTable transactions={transactions} columns={columns} />
          </div> 
           <LiveTradingForm />
        </>
      )}
    </div>
  );
};

export default Dashboard;
